module.exports = __webpack_public_path__ + "img/popup_file_upload.6f797fc1.svg";